module.exports = __webpack_public_path__ + "img/bell-white.bdf0e893.svg";